export default function blockFadeUp() {
    gsap.utils
        .toArray('.content > div:not(.team-member-modals):not(.team-member-modal)')
        .forEach(function(item) {

            gsap.from(item, {
                duration: 0.5,
                autoAlpha: 0,
                y: 64,
                ease: 'sine.inOut',
                scrollTrigger: {
                    trigger: item,
                    start: 'top 110%',
                }
            });

        });
}